import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { invoiceStatus } from "../../enums";
import { formatAsCurrency } from "../../utils";

export const invoiceDisplayFormatter = (item) => {
  const statusIndicator =
    item.status === invoiceStatus.overdue
      ? { statusText: "Overdue", statusType: "red" }
      : item.status === invoiceStatus.paid
      ? { statusText: "Paid", statusType: "blue" }
      : item.status === invoiceStatus.outstanding
      ? { statusText: "Outstanding", statusType: "gray" }
      : { statusText: "Draft", statusType: "green" };

  return {
    ...item,
    amount: (
      <strong>
        {item.currencySymbol} {formatAsCurrency(item.amount)}
      </strong>
    ),
    status: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    description: <strong>{item.description}</strong>,
    customer: item.customer.email,
    date: <span className="date--oneline">{item.date}</span>,
    more: <OverflowMenuVertical />,
  };
};
